import { JWT_KEY } from './localStorageKeys'

export function getToken() {
  return localStorage.getItem(JWT_KEY)
}

export function setToken(token) {
  return localStorage.setItem(JWT_KEY, token)
}

export function removeToken() {
  return localStorage.removeItem(JWT_KEY)
}
